interface Props {
    children: React.ReactNode;
}

export function Container({ children }: Props) {
    return (
        <div className="flex gap-y-4 h-full border-2 border-t-0 border-gray-300 bg-white rounded-b-md overflow-hidden">
            {children}
        </div>
    );
}